import * as React from 'react'

const SvgNewTabIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 16.25H3.75V3.75h5.625V2.5H3.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-5.625h-1.25v5.625zm0-12.5v-2.5H15v2.5h-2.5V5H15v2.5h1.25V5h2.5V3.75h-2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgNewTabIcon
